import React from "react";
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import ChatbotWidget from "../../components/chatbot/ChatBot";
import "./Home.css";
import logo from "../../../assets/img/Logo.webp";
import Main_logo from "../../../assets/img/Ai-powered-cv-logo.png";

const LandingPage = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  const handleLogout = () => {
    localStorage.removeItem("token"); // Clear the token
    navigate("/login"); // Redirect to login page
  };

  return (
    <div>
      {/* Hero Section */}
      <section
        className="hero bg-dark text-white d-flex align-items-center"
        style={{
          minHeight: "100vh",
          background: "linear-gradient(to right, #4e54c8, #8f94fb)",
        }}
      >
        <Container className="text-center">
          <img src={Main_logo} alt="" />
          <h1 className="display-3 font-weight-bold mb-4 hero-title">
            Create Your Perfect CV in Minutes with AI
          </h1>
          <p className="lead mb-5 hero-subtitle">
            Let AI craft a professional, personalized CV that gets noticed.
          </p>
          <div className="d-flex justify-content-center">
            {token ? (
              <>
                <Button
                  variant="success"
                  size="lg"
                  className="mr-3 custom-btn"
                  onClick={() => navigate("/dashboard")}
                >
                  Create CV
                </Button>
                <Button
                  variant="outline-light"
                  size="lg"
                  className="custom-btn"
                  onClick={handleLogout}
                  style={{ marginLeft: "10px" }}
                >
                  Logout
                </Button>
              </>
            ) : (
              <>
                <Button
                  variant="success"
                  size="lg"
                  className="mr-3 custom-btn"
                  onClick={() => navigate("/signup")}
                >
                  Sign Up
                </Button>
                <Button
                  variant="outline-light"
                  size="lg"
                  className="custom-btn"
                  onClick={() => navigate("/login")}
                  style={{ marginLeft: "10px" }}
                >
                  Login
                </Button>
              </>
            )}
          </div>
        </Container>
      </section>

      {/* Introduction Section */}
      <section id="introduction" className="py-5">
        <Container className="text-center">
          <h2 className="section-heading mb-4">What Makes Us Unique?</h2>
          <Row>
            <Col md={6}>
              <img
                src={logo}
                alt="AI CV Maker"
                className="img-fluid mb-4 w-25 rounded"
              />
            </Col>
            <Col md={6}>
              <p className="lead">
                Our AI-powered CV maker doesn't just create a generic CV. It
                analyzes your skills, experience, and the job you're targeting
                to create a custom-tailored CV that will get you noticed by
                recruiters. With a variety of professional templates, you'll
                have everything you need in one place!
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Features Section */}
      <section id="features" className="py-5 bg-light">
        <Container>
          <h2 className="text-center mb-5 section-heading">
            Why Choose Our AI CV Maker?
          </h2>
          <Row>
            <Col md={3} className="mb-4">
              <Card className="feature-card shadow-lg d-flex flex-column">
                <Card.Body className="d-flex flex-column">
                  <Card.Title className="feature-title">
                    AI-Powered Customization
                  </Card.Title>
                  <Card.Text className="feature-text">
                    Get a tailor-made CV based on your skills, experience, and
                    job profile.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={3} className="mb-4">
              <Card className="feature-card shadow-lg d-flex flex-column">
                <Card.Body className="d-flex flex-column">
                  <Card.Title className="feature-title">
                    Quick & Easy
                  </Card.Title>
                  <Card.Text className="feature-text">
                    Create your CV in just a few steps. It’s fast and
                    hassle-free.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={3} className="mb-4">
              <Card className="feature-card shadow-lg d-flex flex-column">
                <Card.Body className="d-flex flex-column">
                  <Card.Title className="feature-title">
                    Professional Templates
                  </Card.Title>
                  <Card.Text className="feature-text">
                    Choose from a range of sleek, modern templates to make your
                    CV stand out.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={3} className="mb-4">
              <Card className="feature-card shadow-lg d-flex flex-column">
                <Card.Body className="d-flex flex-column">
                  <Card.Title className="feature-title">
                    Instant Download
                  </Card.Title>
                  <Card.Text className="feature-text">
                    Download your polished CV instantly in multiple formats.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <ChatbotWidget />
        </Container>
      </section>

      {/* CTA Section */}
      <section
        id="cta"
        className=" text-white py-5 text-center"
        style={{ background: "linear-gradient(to right, #4e54c8, #8f94fb)" }}
      >
        <Container>
          <h2 className="cta-heading">Ready to Get Started?</h2>
          <p className="cta-subtitle mb-4">
            Create your standout CV today and make the first step towards your
            dream job!
          </p>
          <Button
            variant="light"
            size="lg"
            className="custom-btn"
            onClick={() => navigate("/resumescorer")}
          >
            Check your Resume Score
          </Button>
        </Container>
      </section>
    </div>
  );
};

export default LandingPage;